import { inferRouteObject } from 'react-router-typed-object';
import { z } from 'zod';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import HeaderTag, { CompanyFloorRuleFormSearchKey, PlacementSearchKey, TagDetailsTab, TagFormSearchKey } from 'src/scenes/HeaderTag';
import Status from 'src/scenes/Status';

const index = true;

export const headerTagRouteObject = inferRouteObject({
  path: 'header-tag',
  element: <PrivateRoute roles={or(Roles.ADMIN, Roles.HEADER_TAG)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: HeaderTag.Helmet,
      children: [
        {
          index,
          element: <Navigate to='./tags' replace />,
        },
        {
          path: 'tags',
          children: [
            { index, Component: HeaderTag.TagsList },
            {
              path: 'create',
              Component: HeaderTag.TagForm,
            },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                {
                  path: ':headerTagId',
                  Component: HeaderTag.TagForm,
                  searchParams: z.object({
                    [TagFormSearchKey.TAG_DETAILS_TAB]: z.string().optional(),
                  }).parse,
                },
              ],
            },
            {
              path: ':headerTagId',
              children: [
                { index, element: <Navigate to='./placements' replace /> },
                {
                  Component: HeaderTag.TagDetails.Layout,
                  children: [
                    { path: TagDetailsTab.placements, Component: HeaderTag.TagDetails.PlacementsList },
                    { path: TagDetailsTab.rawScripts, Component: HeaderTag.TagDetails.RawScriptsList },
                    { path: TagDetailsTab.disableRules, Component: HeaderTag.TagDetails.DisableRuleList },
                    { path: TagDetailsTab.dynamicPlacements, Component: HeaderTag.TagDetails.DynamicPlacementsList },
                    {
                      path: TagDetailsTab.floorRule,
                      children: [{ index, Component: HeaderTag.TagDetails.FloorRule }],
                    },
                  ],
                },
                {
                  path: TagDetailsTab.floorRule,
                  children: [
                    { path: 'create', Component: HeaderTag.FloorRuleForm },
                    {
                      path: 'edit',
                      children: [
                        { index, element: <Navigate to='../' replace /> },
                        { path: ':floorRuleId', Component: HeaderTag.FloorRuleForm },
                      ],
                    },
                  ],
                },
                { path: 'bidders-assign', Component: HeaderTag.TagDetails.BiddersAssign },
                {
                  path: 'placement',
                  children: [
                    {
                      index,
                      Component: HeaderTag.TagDetails.Placement,
                    },
                    {
                      path: ':placementId',
                      children: [
                        { index, Component: HeaderTag.TagDetails.Placement },
                        { path: 'history', Component: HeaderTag.TagDetails.PlacementHistory },
                      ],
                    },
                  ],
                  searchParams: z.object({
                    [PlacementSearchKey.CLONE_ID]: z.string().optional(),
                  }).parse,
                },
              ],
            },
          ],
        },
        { path: 'raw-scripts', Component: HeaderTag.RawScriptsList },
        {
          path: 'floor-rules',
          children: [
            { index, Component: HeaderTag.FloorRulesList },
            {
              path: 'create',
              Component: HeaderTag.FloorRuleForm,
              searchParams: z.object({
                [CompanyFloorRuleFormSearchKey.HEADER_TAG_ID]: z.string().optional(),
              }).parse,
            },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                {
                  path: ':floorRuleId',
                  Component: HeaderTag.FloorRuleForm,
                  searchParams: z.object({
                    [CompanyFloorRuleFormSearchKey.HEADER_TAG_ID]: z.string().optional(),
                  }).parse,
                },
              ],
            },
          ],
        },
        {
          path: 'bidders-configs',
          children: [
            { index, Component: HeaderTag.BiddersConfigsList },
            { path: 'create', Component: HeaderTag.BidderConfigForm },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                { path: ':bidderId', Component: HeaderTag.BidderConfigForm },
              ],
            },
          ],
        },
        { path: '*', element: <Navigate to='./tags' replace /> },
      ],
    },
  ],
});
